import { render, staticRenderFns } from "./BoxContent4.vue?vue&type=template&id=5a695b09&scoped=true"
import script from "./BoxContent4.vue?vue&type=script&lang=js"
export * from "./BoxContent4.vue?vue&type=script&lang=js"
import style0 from "./BoxContent4.vue?vue&type=style&index=0&id=5a695b09&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a695b09",
  null
  
)

export default component.exports